import "./Chat.scss";

import { Container, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ChatMessage from "./ChatMessage";
import NewChatOptions from "./NewChatOptions";
import { getActiveSession } from "../utils/Functions";
import { setBotsMenuOpen } from "../redux/chatSlice";

function Chat() {
  const dispatch = useDispatch();
  const chatContainerRef = useRef(null);
  const activeSession = useSelector((state) => state.chat.activeSession);
  const chatSessions = useSelector((state) => state.chat.chatSessions) || [];
  const isLoading = useSelector((state) => state.chat.isLoading);
  const loadingText = useSelector((state) => state.chat.loadingText);
  const user = useSelector((state) => state.chat.user);

  const activeSessionData = getActiveSession(chatSessions, activeSession);
  const activeSessionMessages = activeSessionData?.messages || [];
  const showOptions = activeSessionMessages.length === 0;

  const isUserAtBottomRef = useRef(true);
  const [isUserInteracting, setIsUserInteracting] = useState(false);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  const handleScroll = () => {
    const container = chatContainerRef.current;
    const atBottom =
      Math.abs(
        container.scrollHeight - container.scrollTop - container.clientHeight
      ) < 100;

    isUserAtBottomRef.current = atBottom;
    setIsUserInteracting(!atBottom);
  };

  useEffect(() => {
    if (isUserAtBottomRef.current && !isUserInteracting) {
      scrollToBottom();
    }
  }, [activeSessionMessages, isLoading, isUserInteracting]);

  useEffect(() => {
    const container = chatContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <div
      ref={chatContainerRef}
      className={`chat-container ${user ? "chat-user" : "chat-noUser"}`}
    >
      <Container
        className="chat"
        onClick={() => dispatch(setBotsMenuOpen(false))}
      >
        {activeSessionMessages.map((message, index) =>
          message.hidden ? <></> : <ChatMessage key={index} message={message} />
        )}
        {showOptions && <NewChatOptions />}
        {isLoading && (
          <div className="chat-loading-container">
            <Typography className="chat-loading">{loadingText}</Typography>
          </div>
        )}
      </Container>
    </div>
  );
}

export default Chat;
